import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M18 18h-6a3 3 0 0 1 -3 -3v-10l-4 4m8 0l-4 -4","key":"svg-0"}]]

/**
 * IconCornerLeftUp
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItY29ybmVyLWxlZnQtdXAiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTE4IDE4aC02YTMgMyAwIDAgMSAtMyAtM3YtMTBsLTQgNG04IDBsLTQgLTQiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/corner-left-up
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconCornerLeftUp = createReactComponent('outline', 'corner-left-up', 'CornerLeftUp', __iconNode);

export default IconCornerLeftUp;